import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx";
import { useTranslation } from 'react-i18next';
import "../customerMaster/customerListing.css";
import "./reports.css";
import { useReportCards } from "../shared/reportCards";

const paymentMethodList = [{ value: "All", text: "All" }];

const LeaseReceiptReport = () => {
    const { t } = useTranslation(['reports', 'common']);
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const gridRef = useRef();
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        tenantId: "",
        tenantName: "",
        leaseNo: "",
        unitNo: "",
        paymentMethod: { label: "All", value: "All" },
        from: "",
        to: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();
        const fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        setFormData((prev) => ({
            ...prev,
            from: formatDate(fromDate),
            to: formatDate(toDate),
        }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchLeaseNos,LRAgreeSearchCustomers,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const addAllOption = (list) => [{ value: 'All', text: 'All' }, ...list || []];
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
            setLeaseList(addAllOption(res?.data?.dropdowns?.LeaseNo));
            setTanentList(addAllOption(res?.data?.dropdowns?.LRAgreeSearchCustomers));
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const dateFormatter = (params) => {
        if (!params.value) return '';
        const date = moment(params.value);
        return date.isValid() ? date.format('DD-MMM-YYYY') : '';
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const amountFormatter = (params) => {
        if (params?.value === null || params?.value === undefined) return '';
        return Number(params.value).toFixed(currencyPrecision?.decimalNumbers || 2);
    };
    const buildParams = (newPageNo, size) => {
        const today = new Date();
        let todate = formatDate(today)
        const oneYearBack = new Date();
        oneYearBack.setFullYear(today.getFullYear() - 1);
        const updatedValue = formatDate(oneYearBack);
        const params = new URLSearchParams();
        params.append("PageNo", newPageNo || 1);
        params.append("PageSize", size);
        params.append("FromDate", formData?.from || updatedValue);
        params.append("ToDate", formData?.to || todate);
        params.append("PropertyNo", formData?.property?.value?.value || "All");
        params.append("UnitNo", formData?.unitNo?.label || "All");
        params.append("TenantNo", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
        params.append("LeaseNo", formData?.leaseNo?.label || "All");
        params.append("PaymentMethod", formData?.paymentMethod?.label || "All");
        return params;
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = buildParams(newPageNo, pageSize || 50);
            const res = await apiService.getApiParamater("REPORT_LEASE_RECEIPTS", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            const params = buildParams(1, total?.totalRecords);
            const res = await apiService.getApiParamater("REPORT_LEASE_RECEIPTS", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
        }
    }
    const columnDefs = [
        { headerName: t('reports:leaseReceipt.columns.propertyNo'), field: "property_No", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left" },
        { headerName: t('reports:leaseReceipt.columns.propertyName'), field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left" },
        { headerName: t('reports:leaseReceipt.columns.unitNo'), field: "unit_No", filter: true, floatingFilter: true, suppressMovable: true, width: 100, pinned: "left" },
        { headerName: t('reports:leaseReceipt.columns.tenantNo'), field: "tenantNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:leaseReceipt.columns.tenantName'), field: "tenantName", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: t('reports:leaseReceipt.columns.leaseNo'), field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:leaseReceipt.columns.installmentDesc'), field: "installment_Desc", filter: true, floatingFilter: true, suppressMovable: true, width: 180 },
        {
            headerName: t('reports:leaseReceipt.columns.paymentDate'), field: "paymentDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: t('reports:leaseReceipt.columns.paymentMethod'), field: "paymentMethod", filter: true, floatingFilter: true, suppressMovable: true, width: 150 },
        { headerName: t('reports:leaseReceipt.columns.chequeNo'), field: "chequeNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        {
            headerName: t('reports:leaseReceipt.columns.chequeDate'), field: "chequeDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        {
            headerName: t('reports:leaseReceipt.columns.amount'), field: "amount", filter: true, floatingFilter: true, suppressMovable: true, width: 130,
            valueFormatter: amountFormatter,
        },
        { headerName: t('reports:leaseReceipt.columns.voucherNo'), field: "voucherNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:leaseReceipt.columns.remarks'), field: "remarks", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: t('reports:leaseReceipt.columns.createdBy'), field: "createdBy", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        {
            headerName: t('reports:leaseReceipt.columns.createdOn'), field: "createdOn", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
    ]
    const handleClearFilters = () => {
        setUnitList([])
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        setFormData({
            property: { label: "All", value: "All" },
            tenantId: "",
            tenantName: "",
            leaseNo: "",
            unitNo: "",
            paymentMethod: { label: "All", value: "All" },
            from: formatDate(fromDate),
            to: formatDate(toDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === "tenantId") {
            setFormData(prev => ({ ...prev, [name]: value, tenantName: { label: value?.value?.text, value: value?.value } }));
        } else if (name === "tenantName") {
            setFormData(prev => ({ ...prev, [name]: value, tenantId: { label: value?.value?.value, value: value?.value } }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const loadOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "Property No", dataKey: "property_No" },
        { header: "Property Name", dataKey: "property_Name" },
        { header: "Unit No", dataKey: "unit_No" },
        { header: "Tenant No", dataKey: "tenantNo" },
        { header: "Tenant Name", dataKey: "tenantName" },
        { header: "Lease No", dataKey: "leaseNo" },
        { header: "Installment Desc", dataKey: "installment_Desc" },
        { header: "Payment Date", dataKey: "paymentDate" },
        { header: "Payment Method", dataKey: "paymentMethod" },
        { header: "Cheque No", dataKey: "chequeNo" },
        { header: "Cheque Date", dataKey: "chequeDate" },
        { header: "Amount", dataKey: "amount" },
        { header: "Voucher No", dataKey: "voucherNo" },
        { header: "Remarks", dataKey: "remarks" },
        { header: "Created By", dataKey: "createdBy" },
        { header: "Created On", dataKey: "createdOn" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Lease Receipt Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Period: ${formData?.from} to ${formData?.to}`,
            doc.internal.pageSize.width - 220,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Lease_Receipt_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const excelData = exportData.map(item => {
            const row = {};
            exportColumns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Lease Receipts");
        XLSX.writeFile(workbook, "Lease_Receipt_Report.xlsx");
    };
    const cards = useReportCards({
        label: "Receipts in view",
        rowData,
        exportData: exportData,
        pagination,
        fields: [["paymentMethod",3],["property_Name",1]],
    });

    return (
        <div className="cl-page rpt-legacy">
            <div className="cl-titlebar">
                <div className="cl-title">
                    <h1>{t('reports:leaseReceipt.title')}</h1>
                    <p>{t('reports:leaseReceipt.description', 'Receipts posted against leases in the period.')}</p>
                </div>
            </div>
            {cards.strip}
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">{t('common:searchParameters')}</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:property')} </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('reports:tenantId')}</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantId}
                                    loadOptions={loadOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantId", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:leaseNo')}</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseNo', value: selectedOption })}
                                    options={leaseList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:unitNo')} </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:tenant')}</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantName}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantName", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('reports:paymentMethod')}</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.paymentMethod}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'paymentMethod', value: selectedOption })}
                                    options={paymentMethodList?.map(item => ({ value: item, label: item?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">{t('common:from')}</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">{t('common:to')}</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100 datepicker-icon"
                                />
                            </div>
                            <div className="d-flex mt-2 gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">{t('common:search')}</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">{t('common:reset')}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>{t('common:loading')}</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">{t('reports:leaseReceipt.title')}</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                {t('reports:exportAsPdf')}
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                {t('reports:exportAsExcel')}
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={cards.shownRows}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            {!cards.active && <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />}
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default LeaseReceiptReport;
